const INTERNAL_URL_BASE = "https://lyft-zone.invalid";

function isSafeInternalPath(value) {
  return (
    value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.includes("\\") &&
    !/%5c/i.test(value) &&
    // eslint-disable-next-line no-control-regex
    !/[\u0000-\u001f\u007f]/.test(value)
  );
}

export function normalizeInternalReturnPath(value) {
  if (typeof value !== "string") {
    return null;
  }

  const candidate = value.trim();
  if (!isSafeInternalPath(candidate)) {
    return null;
  }

  try {
    const parsed = new URL(candidate, INTERNAL_URL_BASE);
    if (parsed.origin !== INTERNAL_URL_BASE) {
      return null;
    }
    const normalized = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    return isSafeInternalPath(normalized) ? normalized : null;
  } catch {
    return null;
  }
}

export function readValidatedNext(search = "") {
  const next = new URLSearchParams(search).get("next");
  return normalizeInternalReturnPath(next);
}

export function buildAuthEmailRecoveryPath(returnPath) {
  const next = normalizeInternalReturnPath(returnPath) || "/";
  return `/auth/email?next=${encodeURIComponent(next)}`;
}

export function buildLoginRecoveryPath(returnPath) {
  const next = normalizeInternalReturnPath(returnPath) || "/";
  return `/login?next=${encodeURIComponent(next)}`;
}

export function isAuthFlowPath(pathname) {
  return pathname === "/login" || pathname === "/auth" || pathname.startsWith("/auth/");
}
